// drawio embed エディタを全画面モーダルで開く。
// drawio 公式 embed プロトコル (iframe + window.postMessage, JSON 文字列) を使う。
// https://www.drawio.com/doc/faq/embed-mode
//
//   init   : iframe 準備完了 → こちらから {action:'load', xml} を送る
//   save   : ユーザーが保存 → xml が届く。続けて {action:'export', format:'png'} を要求
//   export : PNG dataURI が届く → {xml, pngBlob} を onSave に渡す
//   exit   : エディタを閉じる
//
// onSave({ xml, pngBlob }) は呼び出し側 (editor_controller) が添付アップロード等を行う。

import { dataUriToBlob } from "./image_upload"

export function openDrawioEditor({ xml = "", embedUrl, onSave }) {
  const base = (embedUrl || "https://embed.diagrams.net").replace(/\/$/, "")
  const src = `${base}/?embed=1&proto=json&spin=1&modified=unsavedChanges&ui=min&noSaveBtn=0&saveAndExit=1`

  const overlay = document.createElement("div")
  overlay.className = "akebono-drawio-modal"

  const iframe = document.createElement("iframe")
  iframe.className = "akebono-drawio-iframe"
  iframe.setAttribute("frameborder", "0")
  iframe.src = src
  overlay.appendChild(iframe)
  document.body.appendChild(overlay)

  let pendingXml = xml // save イベントで受け取った最新 XML を保持

  const post = (msg) => iframe.contentWindow?.postMessage(JSON.stringify(msg), "*")

  const cleanup = () => {
    window.removeEventListener("message", onMessage)
    overlay.remove()
  }

  function onMessage(evt) {
    // drawio からのメッセージのみ処理 (JSON 文字列)
    if (typeof evt.data !== "string" || !evt.data.startsWith("{")) return
    let msg
    try { msg = JSON.parse(evt.data) } catch (_) { return }

    switch (msg.event) {
      case "init":
        post({ action: "load", xml: pendingXml || "", autosave: 1 })
        break
      case "save":
        pendingXml = msg.xml
        // PNG プレビューを書き出させる
        post({ action: "export", format: "png", spin: "エクスポート中" })
        break
      case "export": {
        const png = msg.data ? dataUriToBlob(msg.data) : null
        try {
          onSave?.({ xml: pendingXml, pngBlob: png })
        } finally {
          cleanup()
        }
        break
      }
      case "exit":
        cleanup()
        break
    }
  }

  window.addEventListener("message", onMessage)

  // Esc で閉じる (保存せず)
  overlay.addEventListener("keydown", (e) => { if (e.key === "Escape") cleanup() })

  return cleanup
}
